import { Col, Row, Text, TouchField, Table, BgIcon } from 'components';
import React, { useMemo } from 'react';
import Store from 'store';
import { useNavFunc } from 'navigation';
import { SCREEN, COLOR, COLORS } from 'const';
import { Image } from 'react-native';
import moment from 'moment';
import { ASSETS } from 'assets';
import { Feather, EvilIcons, AntDesign } from '@expo/vector-icons';
import { commonFuncs } from './ListOrders.funcs';
import RequestUtils from 'store/api-client/Request.utils';
import { ClientName, DateDispatched, DownloadArtwork, OrderLineItems, OrderNo, PreviewIcon, TrackingID } from './ListOrders.Comps';
import { ColumnsType } from 'antd/es/table';
import { Tag, Button, Popover } from 'antd';
import OrderActions from './OrderActions';
import { TCMSOrder } from 'type';
import { ORDER_STAGE, ORDER_STATUS, STATUS_BY_STAGE } from 'store/Order.Store';
import { ValHelper } from 'helpers';
import { MICRO_SERVICES_HOST } from 'store/Order.Store';

const getStatusTxt = (order: TCMSOrder, OrderStore) => {
  const { royalMailData } = OrderStore;
  const lastPipeline = order.Pipelines.length === 0 ? undefined : order.Pipelines[order.Pipelines.length - 1];
  const { reprint, isPaid, isAdminApproved, resellerReprint, dispatchedDate } = lastPipeline?.SharedData || {};
  const orderId = order['Order ID'];

  let statusTxt: any = order.Status;
  if (order.Status === "Pending") {
    statusTxt = "Awaiting payment";
    if (isPaid) statusTxt = "Queued for production";
    // if (isPaid && !isAdminApproved) statusTxt = "Held";
  }
  if (order.Status === "Accepted") {
    statusTxt = OrderStore.isInProduction(order) ? "In production" : "Delayed";
    if (!!dispatchedDate) statusTxt = "Manifested"
    if (!!royalMailData[orderId] && !!royalMailData[orderId].data.shippedOn) {
      statusTxt = "Delivered"
    }
  }
  return statusTxt;
}

const OrderTable = ({ isLoading, onRefresh, jobs, setJobs, stage, selectedJobs, setSelectedJobs, isSearch = false, onChangeFilter, onLayout }) => {
  const UserStore = Store.useUserStore();
  const { user } = UserStore;
  const OrderStore = Store.useOrderStore();

  const deleteOrder = async (val) => {
    const success = await commonFuncs.onDelete([val]);
    if (!Boolean(success)) return;
    setJobs(l => l.filter(i => i.Id !== val.Id));
  }

  const stageStatusOpts = useMemo(() => {
    let opts = [];
    if (stage && stage !== "all") {
      opts = STATUS_BY_STAGE[ValHelper.toDisplayStage(stage)] || [];
    }
    if (!opts.length) opts = ORDER_STATUS;
    return opts.map(i => ({ text: i, value: i }))
  }, [stage]);

  const columns: ColumnsType<any> = [
    {
      title: 'No.',
      key: 'orderNo',
      render: (order) => (
        <OrderNo order={order} canShowId={user?.role === 'admin'} />
      )
    },
    // {
    //   title: 'Client',
    //   key: 'client',
    //   render: (order) => (
    //     <ClientName order={order} canShowId={user?.role === 'admin'} />
    //   )
    // },
    {
      title: 'Product',
      key: 'product',
      render: (order) => (
        <OrderLineItems order={order['Raw Data']} supportedItemIDs={order['Item Supported']} />
      )
    },
    {
      title: 'Date created',
      key: 'CreatedAt',
      sorter: true,
      // sorter: (a, b) => moment(a.CreatedAt).unix() - moment(b.CreatedAt).unix(),
      // sortDirections: ['descend'],
      render: (order) => (
        <Text>{moment(order.CreatedAt).format('DD/MM/YYYY')}</Text>
      )
    },
    // (['accepted', 'fulfilled'].includes(status) || isSearch) && {
    //   title: 'Date dispatched',
    //   key: 'dateDispatched',
    //   render: (order) => (
    //     <DateDispatched order={order} />
    //   )
    // },
    {
      title: 'Status',
      key: 'stageStatus',
      filters: stageStatusOpts,
      // onFilter: (value, order) => {
      //   const statusTxt = getStatusTxt(order, OrderStore);
      //   return statusTxt === value;
      // },
      render: (order) => {
        let statusTxt;
        if (order.StageStatus) {
          statusTxt = order.StageStatus;
        } else {
          statusTxt = getStatusTxt(order, OrderStore);
        }
        return (
          <Col alignItems="flex-start">
            <Tag bordered={false} color={COLORS.BG_DARKER}>
              <Text>{statusTxt}</Text>
            </Tag>
            {/* {!!reprint && (
              <Text caption mt0>FOC - reprint</Text>
            )}
            {!!resellerReprint && (
              <Text caption mt0>Reprint</Text>
            )} */}
          </Col>
        )
      }
    },
    {
      title: 'Stage',
      key: 'stage',
      filters: stage === "all" ? ORDER_STAGE.map(i => ({ text: i, value: i })) : undefined,
      render: (order) => {
        // const lastPipeline = order.Pipelines.length === 0 ? undefined : order.Pipelines[order.Pipelines.length - 1];
        // const { reprint, isPaid, isAdminApproved, resellerReprint, dispatchedDate } = lastPipeline?.SharedData || {};
        // const { royalMailData } = OrderStore;
        let stageTxt = order.Status;
        if (order.Status === "Pending") {
          stageTxt = "Pre production";
        }
        if (order.Status === "Accepted") {
          stageTxt = "In production";
          // if (!!dispatchedDate) stageTxt = "Fulfillment"
          // if (!!royalMailData[orderId] && !!royalMailData[orderId].data.shippedOn) {
          //   stageTxt = "Fulfillment"
          // }
        }
        if (order.Status === "Fulfilled") stageTxt = "Fulfillment"
        if (order.Status === "Rejected") stageTxt = "Cancelled"
        if (order.Stage) stageTxt = order.Stage
        return (
          <Col alignItems="flex-start">
            <Tag bordered={false} color={COLORS.BG_DARKER}>
              <Text>{stageTxt}</Text>
            </Tag>
          </Col>
        )
      }
    },
    window.location.href.includes("debug=1") && {
      title: 'Pipeline',
      key: 'pipelineRef',
      render: (order) => {
        const openLink = () => {
          window.open(`${MICRO_SERVICES_HOST}/pipeline?slug=${order.ApiSlug || "itl"}&orderId=${order["Order ID"]}&token=${RequestUtils.getToken()}`, '_blank');
        }
        return (
          <Col alignItems="flex-start" onPress={openLink}>
            <Tag>
              <Text>Open</Text>
            </Tag>
          </Col>
        )
      }
    },
    {
      title: 'Order type',
      key: 'orderType',
      filters: ["Shopify", "Sample"].map(i => ({ text: i, value: i })),
      render: (order) => {
        const lastPipeline = order.Pipelines.length === 0 ? undefined : order.Pipelines[order.Pipelines.length - 1];
        const { isSampleRequest } = lastPipeline?.SharedData || {};

        return (
          <Col alignItems="flex-start">
            {(order['Raw Data']?.is_sample_request || isSampleRequest || order.OrderType === "Sample") ? (
              <Tag bordered={false} color="#D6E0FF">
                <Text color="#2952CC">Sample</Text>
              </Tag>
            ) : (
              <Tag bordered={false} color="default">
                <Text color="#2952CC">Shopify</Text>
              </Tag>
            )}
          </Col>
        )
      }
    },
    (['in-production', 'all'].includes(stage) || isSearch) && {
      title: 'Artwork',
      key: 'artwork',
      render: (order) => (
        <DownloadArtwork order={order} apiSlug={order.ApiSlug} onRefresh={onRefresh} />
      )
    },
    // (status === 'accepted' || isSearch) && {
    //   title: 'Packing Slips',
    //   key: 'packingSlip',
    //   render: (order) => (
    //     <Col>
    //       <a href={`${RequestUtils.host}/api/online-stores/order-packing-slips/${order['Order ID']}?clientId=${order['Client ID']}`} target="_blank" style={{ textDecoration: 'none' }}
    //       >
    //         <TouchField cirle middle>
    //           {/* PACKING SLIPS */}
    //           <Feather name="external-link" size={24} color="black" />
    //         </TouchField>
    //       </a>
    //     </Col>
    //   )
    // },
    // (status === 'fulfilled' || isSearch) && {
    //   title: 'Info Job',
    //   key: 'infoJob',
    //   render: (order) => (
    //     <TrackingID order={order} />
    //   )
    // },
    {
      title: 'Actions',
      key: 'actions',
      render: (order) => {
        return <OrderActions order={order} stage={stage} isSearch={isSearch} />
      }
    }
  ].filter(Boolean);

  return (
    <Col onLayout={onLayout}>
      <Table
        data={jobs}
        columns={columns}
        rowKey={val => `${val.Id}_${val['Order ID']}`}
        minWidth={800}
        loading={isLoading}
        rowSelection={(user?.role !== 'admin' && ['fulfillment', 'cancelled'].includes(stage)) ? undefined : {
          selectedRowKeys: Object.keys(selectedJobs),
          onChange: (selectedRowKeys) => {
            const obj = {};
            selectedRowKeys.forEach(i => obj[i] = true);
            setSelectedJobs(obj);
          },
        }}
        onChange={onChangeFilter}
        onRow={(val, idx) => ({
          onClick: () => {
            const rowKey = `${val.Id}_${val['Order ID']}`;
            const isSelected = selectedJobs[rowKey];
            const obj = { ...selectedJobs };
            if (isSelected) {
              delete obj[rowKey];
            } else {
              obj[rowKey] = true;
            }
            setSelectedJobs(obj);
          }
        })}
      />
    </Col>
  )
};

export default OrderTable;
